import { render } from "./Position.vue?vue&type=template&id=a01f71e4&scoped=true"
import script from "./Position.vue?vue&type=script&lang=js"
export * from "./Position.vue?vue&type=script&lang=js"

import "./Position.vue?vue&type=style&index=0&id=a01f71e4&scoped=true&lang=css"
import "./Position.vue?vue&type=style&index=1&id=a01f71e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a01f71e4"]])

export default __exports__